const clearLocalStorage = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("as-username");
  localStorage.removeItem("as-currentCustomer");
  localStorage.removeItem("as-currentStore");
  localStorage.removeItem("currentAppName");
  localStorage.removeItem("as-languageList");
  localStorage.removeItem("as-languageData");
  localStorage.removeItem("as-currentMenuIndex");
  localStorage.removeItem("as-adminPage");
  localStorage.removeItem("as-buttonPermission");
  localStorage.removeItem("as-viewPermissions");
  localStorage.removeItem("as-pluginPermissions");
  localStorage.removeItem("as-servicePage");
  localStorage.removeItem("as-loginFlag");
  localStorage.removeItem("noShowTips");
};

export { clearLocalStorage };
